import { render } from "./JobItemsSmall.vue?vue&type=template&id=23a2fbd4"
import script from "./JobItemsSmall.vue?vue&type=script&lang=js"
export * from "./JobItemsSmall.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__